import { ForgotPasswordPage } from './ForgotPasswordPage';
import { withForgotPasswordPage } from './withForgotPasswordPage';

const ConnectedForgotPasswordPage = withForgotPasswordPage(ForgotPasswordPage);

export { ConnectedForgotPasswordPage as ForgotPasswordPage };
